import {CODE_RESEND_DELAY_IN_SECONDS} from "../components/UserPhoneVerification";

export const getPhoneVerificationCodeRemainingTime = (timerStartTime: number | null): number => {
    if (!timerStartTime) return 0;

    const now = Date.now();
    const elapsed = Math.floor((now - timerStartTime) / 1000);
    const remaining = Math.max(0, CODE_RESEND_DELAY_IN_SECONDS - elapsed);

    return remaining;
};
import {CODE_RESEND_DELAY_IN_SECONDS} from "../components/UserPhoneVerification";

export const getPhoneVerificationCodeRemainingTime = (timerStartTime: number | null): number => {
    if (!timerStartTime) return 0;

    const now = Date.now();
    const elapsed = Math.floor((now - timerStartTime) / 1000);
    const remaining = Math.max(0, CODE_RESEND_DELAY_IN_SECONDS - elapsed);

    return remaining;
};
